import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";

/** The message exactly as it will arrive — rendered by the server in the real e-mail chrome. */
export function EmailPreview({ base, subject, body }) {
  const [html, setHtml] = useState("");
  const [err, setErr] = useState("");
  useEffect(() => {
    const t = setTimeout(() => {
      api.post(`${base}/preview`, { subject, body_html: body })
        .then(({ data }) => { setHtml(data.html); setErr(""); })
        .catch((e) => setErr(e?.response?.data?.detail || "Could not render the preview"));
    }, 300);
    return () => clearTimeout(t);
  }, [base, subject, body]);
  if (err) return <p className="rounded-md border border-rose-200 bg-rose-50 px-3 py-2 text-sm text-rose-700" data-testid="pw-preview-error">{err}</p>;
  if (!html) return <div className="py-10 text-center"><Loader2 className="inline h-5 w-5 animate-spin text-slate-300" /></div>;
  return (
    <div className="space-y-2">
      <p className="truncate rounded-md border border-slate-200 bg-white px-3 py-2 text-sm text-slate-700" data-testid="pw-preview-subject">
        <span className="text-slate-400">Subject: </span>{subject}</p>
      <iframe title="E-mail preview" srcDoc={html} sandbox="" className="h-[560px] w-full rounded-md border border-slate-200 bg-slate-100"
              data-testid="pw-preview-frame" />
    </div>
  );
}
